import React, { useEffect, useState } from "react";

function ResponsiveMedia({ src, onClick, controls = true, muted = true }) {
    const [isPortrait, setIsPortrait] = useState(null);

    const isVideo = (url = "") => /\.(mp4|webm|ogg|mov|m4v)(\?|#|$)/i.test(url);

    useEffect(() => {
        if (!src) return;
        setIsPortrait(null);

        if (isVideo(src)) {
            const v = document.createElement("video");
            v.preload = "metadata";
            v.src = src;

            const onLoaded = () => {
                // videoWidth/videoHeight dispo après loadedmetadata
                setIsPortrait(v.videoHeight > v.videoWidth);
            };

            v.addEventListener("loadedmetadata", onLoaded);
            return () => v.removeEventListener("loadedmetadata", onLoaded);
        } else {
            const img = new Image();
            img.src = src;
            img.onload = () => setIsPortrait(img.naturalHeight > img.naturalWidth);
        }
    }, [src]);

    const containerStyle = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        padding: 10,
        cursor: "pointer",
        height: isPortrait ? "auto" : 400,       // paysage → fixe ; portrait → hauteur libre
        maxHeight: isPortrait ? "90vh" : 400,    // sécurité pour portrait
    };

    const mediaStyle = {
        objectFit: "contain",
        borderRadius: 3,
        cursor: "pointer",
        width: isPortrait ? "auto" : "100%",
        height: isPortrait ? "100%" : "auto",
        maxWidth: "100%",
        maxHeight: "100%",
    };

    if (isPortrait === null) {
        return <div style={containerStyle} />; // ou un skeleton/loader
    }

    return (
        <div style={containerStyle} onClick={onClick}>
            {isVideo(src) ? (
                <video
                    src={src}
                    controls={controls}
                    muted={muted}
                    //autoPlay
                    playsInline
                    preload="metadata"
                    style={mediaStyle}
                    onClick={onClick}
                />
            ) : (
                <img
                    src={src}
                    alt={isPortrait ? "Portrait" : "Paysage"}
                    style={mediaStyle}
                    onClick={onClick}
                />
            )}
        </div>
    );
}

export default ResponsiveMedia;
